module.exports = new __parcel__URL__("select-linear-csv.edbdd797.svg").toString();